export const PORTAL_GROUP_DOWNLOAD_COLS = [
    { field: "name", headerName: "Group Name" },
    { field: "users", headerName: "Users" },
    { field: "policies", headerName: "Policies" },
    { field: "createdAt", headerName: "Creation Time" },
];
